import { render, staticRenderFns } from "./gcPopup.vue?vue&type=template&id=a8c616f2&lang=html&"
import script from "./gcPopup.vue?vue&type=script&lang=js&"
export * from "./gcPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports